import { useContext } from 'react';
import { FloatingButtonUI } from '@/components/ui';
import { WidgetStateContext, ConfigContext } from '@/context';

export function FloatingButton({ zIndex }: { zIndex: number }) {
  const {
    floatingButtonPosition,
    floatingButtonType,
    floatingButtonTheme,
    floatingButtonIcon,
    floatingButtonTabText,
  } = useContext(ConfigContext);
  const { disableFloatingButton, showFloatingButton, toggleOpen } =
    useContext(WidgetStateContext);

  if (disableFloatingButton) {
    return <></>;
  }

  return (
    <FloatingButtonUI
      hide={!showFloatingButton}
      icon={floatingButtonIcon}
      position={floatingButtonPosition}
      tabText={floatingButtonTabText}
      theme={floatingButtonTheme}
      toggleOpen={toggleOpen}
      type={floatingButtonType}
      zIndex={zIndex}
    />
  );
}
